module.exports = __webpack_public_path__ + "static/media/5.83f01e8e.jpg";